import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { FaMoneyBillWave, FaCalculator } from "react-icons/fa";

const Paypal = ({
  amount,
  tipAmountValue,
  forwardFees,
  getPaypalDetail,
  setPayment,
  currency,
  restaurantsDetail,
  onSdkError,
}) => {
  const paypal = useRef();

  const finalAmount = tipAmountValue;

  useEffect(() => {
    let paypalButtons = null;

    const loadPayPalScript = () => {
      if (restaurantsDetail?.paymentConnections?.paypal !== true) return;

      if (!document.getElementById("paypal-sdk")) {
        const script = document.createElement("script");
        script.id = "paypal-sdk";
        script.src = `https://www.paypal.com/sdk/js?client-id=${restaurantsDetail?.paypalClientKey}&disable-funding=credit,card&vault=true`;
        script.async = true;

        script.onload = () => {
          renderPayPalButton();
        };

        script.onerror = () => {
          console.error("Failed to load PayPal SDK.");
          console.error(
            "Failed to load PayPal. Please verify your PayPal Client ID."
          );
          if (onSdkError) onSdkError();
        };

        document.body.appendChild(script);
      } else {
        renderPayPalButton();
      }
    };

    const renderPayPalButton = () => {
      if (paypal.current && window.paypal?.Buttons) {
        paypalButtons = window.paypal.Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    currency_code: "USD",
                    value: finalAmount.toFixed(2),
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            getPaypalDetail(order, finalAmount);
            setPayment("Paypal");
          },
          onError: (err) => {
            console.error("PayPal Error:", err);
            toast.error(err.message);
          },
        });

        paypalButtons.render(paypal.current);
      }
    };

    loadPayPalScript();

    return () => {
      if (paypalButtons) {
        paypalButtons.close();
      }
      if (paypal.current) {
        paypal.current.innerHTML = "";
      }
    };
  }, [finalAmount, restaurantsDetail, getPaypalDetail, setPayment, onSdkError]);

  return (
    <>
      <div ref={paypal}></div>

      {tipAmountValue > 0 && (
        <div className="d-flex align-items-center justify-content-between">
          <span className="d-flex align-items-center fs--14 fw--500">
            <FaMoneyBillWave className="mr-2 text-success" />
            Total Order Amount:
          </span>
          <span className="fs--14">
            {currency || "$"} {parseFloat(amount).toFixed(2)}
          </span>
        </div>
      )}

      <hr style={{ borderColor: "#444" }} />

      <div className="d-flex align-items-center justify-content-between">
        <span className="d-flex align-items-center fs--16 fw--600">
          <FaCalculator className="mr-2 text-info" />
          Tip Added:
        </span>
        <span className="fs--16 fw--600 text-primary">
          {finalAmount ? finalAmount.toFixed(2) : "0.00"} {currency || "USD"}
        </span>
      </div>
    </>
  );
};

export default Paypal;
